
type WindowMessageTypeFunction<T> = (messageType: T) => void;

export class WindowMessageListener<T> {

    constructor(private executeMessage: WindowMessageTypeFunction<T>) {
        this.executeMessage = executeMessage;
        window.addEventListener("message", (event: MessageEvent) => this.receiveMessage(event), false);
    }

    private receiveMessage(event: MessageEvent) {
        if (!event.isTrusted) return;
        if (this.executeMessage)
            this.executeMessage((event.data as T));
    }

    public dettach() {
        window.removeEventListener("message", this.receiveMessage);
    }
}
